import { render, staticRenderFns } from "./ProductAddedToBasketModal.vue?vue&type=template&id=6834cea6&scoped=true&"
import script from "./ProductAddedToBasketModal.vue?vue&type=script&lang=js&"
export * from "./ProductAddedToBasketModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductAddedToBasketModal.vue?vue&type=style&index=0&id=6834cea6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6834cea6",
  null
  
)

export default component.exports